import React from 'react';
import './InformationCard.scss';
import { ReactComponent as InfoIcon } from '../../assets/images/info.svg';

interface IInformationCardPropTypes {
  text?: string;
}

export default function InformationCard({
  text,
}: Readonly<IInformationCardPropTypes>): React.JSX.Element {
  return (
    <div className="information-card-container">
      <div className="information-icon">
        <InfoIcon />
      </div>
      {text}
    </div>
  );
}
